import React from "react"
import Layout from "../components/Layout"
import Slider from "../components/Slider"

export default () => {
  return (
    <Layout>
      <Slider />
    </Layout>
  )
}
